import { Component, Input, OnInit, inject } from '@angular/core';

import { faCloudDownloadAlt, faFile } from '@fortawesome/pro-solid-svg-icons';
import { ButtonFillMode } from '@progress/kendo-angular-buttons';
import { saveAs } from 'file-saver';

import { IconsService } from '@nexweb/shared/icon-helper';
import { ButtonComponent } from '@nexweb/shared/ui/button';
import { isNullOrUndefined } from '@nexweb/util';

@Component({
  selector: 'nexweb-file-for-download',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './file-for-download.component.html',
})
export class FileForDownloadComponent implements OnInit {
  @Input() file: File;
  @Input() fillMode: ButtonFillMode = 'flat';

  public icon = faFile;
  public fileLabel: string;
  public downloadIcon = faCloudDownloadAlt;

  private iconsService = inject(IconsService);

  ngOnInit() {
    this._initialize();
  }

  public fileClickHandler(): void {
    saveAs(this.file);
  }

  private _initialize() {
    this.downloadIcon = faCloudDownloadAlt;

    const fileNameAsAry = this.file.name?.split(`.`);
    const fileExtensionIndex = fileNameAsAry.length - 1; // last element in array

    if (!isNullOrUndefined(fileNameAsAry[fileExtensionIndex])) {
      const iconFromFileName = this.iconsService.getIconByExtension(fileNameAsAry[fileExtensionIndex]);

      // getIconByExtension returns null for unmapped extensions - faFile is the fallback.
      this.icon = iconFromFileName ?? faFile;
    }

    this.fileLabel = `${this.file.name} ${this.file.size}Kb`;
  }
}
